import React from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/layout/MainLayout';
import { useProjectStore } from '../../contexts/projectStoreProvider';
import { useGlobalProject } from '../../contexts/GlobalProjectContext';
import ProjectUploadWizardFlow from '../../components/ProjectUploadWizard';

const ProjectUploadWizard: React.FC = () => {
  const navigate = useNavigate();
  const { refreshProjects } = useProjectStore();
  const { refreshProjects: refreshGlobalProjects } = useGlobalProject();
  const handleSuccess = async (result: any) => {
    const projectId = result?.project_id;
    if (projectId) {
      await refreshGlobalProjects(projectId);
    }
    await refreshProjects();
    if (projectId) {
      navigate(`/app/projects/${projectId}`);
      return;
    }
    navigate('/app/projects');
  };

  return (
    <MainLayout title="New project from XER">
      <ProjectUploadWizardFlow onSuccess={handleSuccess} onCancel={() => navigate('/app/projects')} />
    </MainLayout>
  );
};

export default ProjectUploadWizard;
